import React from 'react';
import { useTranslation } from 'react-i18next';
import qrIcon from '../icons/qr.svg';
import QRIcon from '../icons/QRIcon'
import { useNavigate } from 'react-router-dom';

const CreateSlipFooter = (props) => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    return (
        <div className="padding1 marginTopAuto flexCenter createSlipFooter">
            {/*<div className="marginLeft1 darkBlueBold15">{props.calculatePrice()}</div>*/}
            <button disabled={!props.hasAnyRows} onClick={() => navigate(process.env.PUBLIC_URL + "/finalslip")} className="button button--success bold roundSquare flexEnd flexCenter">
                <QRIcon className='marginRight1' color={!props.hasAnyRows ? "#b6beca" : "white"}/>
                {t('button.createSlip')}
            </button>
        </div>
    );
};

export default CreateSlipFooter;